<template>
    <div class="container-fluid">
        <!-- LOADING -->
        <Loading
            :style="{ display: (user.permissions.superadmin || loaded.drugSafe) && loaded.web ? 'none' : 'block' }"
        />
        <!-- LOADED -->
        <div :style="{ display: (user.permissions.superadmin || loaded.drugSafe) && loaded.web ? 'initial' : 'none' }">
            <div class="mt-2 tabName">
                <h3>{{ user.role === 'superadmin' ? $t('web_users') : $t('users') }}</h3>
            </div>
            <!-- BUTTON: CREATE USER (REQUIRES CREATE_USER PERMISSION) -->
            <div class="row mt-4" v-if="user.permissions.create_user">
                <div class="col-sm-5 mr-5">
                    <router-link :to="{ name: 'user.create' }" class="btn btn-md btn-success">
                        {{ $t('create_user') }}
                    </router-link>
                </div>
            </div>
            <!-- TABS BAR -->
            <div class="d-flex flex-row justify-content-between mt-5 mb-5" v-if="!user.permissions.superadmin">
                <div class="d-flex flex-column" :style="{ width: '49%' }">
                    <button :class="tab === 'web' ? 'btn btn-dark' : 'btn btn-light'" v-on:click="switchTab('web')">
                        {{ $t('web_users') }}
                    </button>
                </div>
                <div class="d-flex flex-column" :style="{ width: '49%' }">
                    <button
                        :class="tab === 'drugSafe' ? 'btn btn-dark' : 'btn btn-light'"
                        v-on:click="switchTab('drugSafe')"
                    >
                        {{ $t('drugsafe_users') }}
                    </button>
                </div>
            </div>
            <!-- WEB AND DRUGSAFE USER INDICES -->
            <div class="row mt-4">
                <div class="col">
                    <WebUserIndex :style="{ display: tab === 'web' ? 'initial' : 'none' }" @loaded="setLoaded('web')" />
                    <DrugSafeUserIndex
                        v-if="!user.permissions.superadmin"
                        :style="{ display: tab === 'drugSafe' ? 'initial' : 'none' }"
                        @loaded="setLoaded('drugSafe')"
                        :pharmacyId="user.pharmacy_id"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/views/partial/Loading';
import DrugSafeUserIndex from './drugSafe/DrugSafeUserIndex';
import WebUserIndex from './web/WebUserIndex';

export default {
    components: { Loading, DrugSafeUserIndex, WebUserIndex },
    data() {
        return {
            loaded: {
                drugSafe: false,
                web: false
            },
            tab: this.$route.params.tab || 'web' // show web user tab by default if not specified
        };
    },
    async created() {},
    computed: {
        ...mapState('account', ['user'])
    },
    methods: {
        // set component loaded
        setLoaded(component) {
            this.loaded[component] = true;
        },
        // switch tab
        switchTab(tabName) {
            this.tab = tabName;
        }
    }
};
</script>
<style scoped>
.btn:focus {
    outline: none;
    box-shadow: none;
}
</style>
